import { createSlice } from "@reduxjs/toolkit";
import ServerRoutes from "../api/routes";
import { get, post } from "../api/http";

const initialState = {
  user: null,
  authenticated: false,
  authError: null,
  authLoading: false,
  isTal: false,
};

const _actionStart = (state, action) => {
  state.authLoading = true;
  state.authError = null;
};
const _actionSuccess = (state, action) => {
  state.authLoading = false;
  state.authError = null;
};
const _actionFailed = (state, action) => {
  state.authLoading = false;
  state.authError = action.payload.error;
};

const _setUser = (state, action) => {
  state.user = action.payload.user;
  state.isTal = action.payload.isTal;
  state.authenticated = action.payload.authenticated;
  state.authLoading = false;
};

const _setUserDetails = (state, action) => {
  let editedUser = { ...state.user };
  for (const [key, value] of Object.entries(action.payload))
    editedUser[key] = value;
  state.user = editedUser;
};

const _editTodo = (state, action) => {
  let editedTodos = { ...state.todos };
  for (const [key, value] of Object.entries(action.payload.body))
    editedTodos[action.payload._id][key] = value;
  state.todos = editedTodos;
};
const auth = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: _setUser,
    setUserDetails: _setUserDetails,
    actionStart: _actionStart,
    actionFailed: _actionFailed,
    actionSuccess: _actionSuccess,
  },
});

const { reducer, actions } = auth;

const { setUser, setUserDetails, actionStart, actionFailed, actionSuccess } =
  actions;

export default reducer;

export const login = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(ServerRoutes.Auth.login, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      localStorage.setItem("callup", data.token);
      return dispatch(
        setUser({
          user: data.user,
          authenticated: true,
          isTal: data.isTal,
        }),
      );
    }
  };
};

export const register = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.Auth.registerDIY,
      body,
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess());
  };
};

export const checkAuth = () => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, status } = await get(ServerRoutes.Auth.checkAuth, {});
    if (status !== 200) return dispatch(actionSuccess());
    else
      return dispatch(
        setUser({
          user: data.user,
          authenticated: true,
          isTal: data.isTal,
        }),
      );
  };
};

// export const logoutAll = () => {
//   return async (dispatch) => {
//     await post(ServerRoutes.Auth.logoutAll, {});
//     localStorage.removeItem("callup");
//     return dispatch(setUser({ user: null, authenticated: false }));
//   };
// };

export const logoutSpecific = () => {
  return async (dispatch) => {
    const { error, status } = await post(ServerRoutes.Auth.logoutSpecific, {});
    if (status !== 200) dispatch(actionFailed(error));
    else {
      localStorage.removeItem("callup");
      return dispatch(
        setUser({
          user: null,
          authenticated: false,
          isTal: false,
        }),
      );
    }
  };
};

export const editDetails = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.User.editDetails, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(setUserDetails(body));
    }
  };
};

export const seperationEvent = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(
      ServerRoutes.Guests.seperationEvent,
      body,
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      return dispatch(actionSuccess());
    }
  };
};
